import { useEffect } from 'react'
import { useHistoryStore } from '@/shared/store/history.store'

/**
 * Prevents window/tab close when there are unsaved changes.
 * Shows a browser warning dialog when user tries to close the tab/window
 * while saveStatus is 'dirty', 'syncing', or 'failed'.
 */
export const usePreventUnsavedChanges = (): void => {
  const { saveStatus } = useHistoryStore()

  useEffect(() => {
    // Only prevent close when there are unsaved changes
    const hasUnsavedChanges =
      saveStatus === 'dirty' ||
      saveStatus === 'syncing' ||
      saveStatus === 'failed'

    if (!hasUnsavedChanges) {
      return
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
      // Modern browsers ignore custom messages and show their own generic warning
      // Setting returnValue is required for the dialog to appear
      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [saveStatus])
}
